import React, { useRef, useState } from "react";
import { motion, useSpring, useReducedMotion } from "framer-motion";

/**
 * Cursor pull. Listeners are local to the element (not global mousemove), so
 * adding more magnetic elements costs nothing per frame. Disabled for coarse
 * pointers and reduced motion; children may be a render prop receiving hover.
 */
const Magnetic = ({
  children,
  strength = 0.32,
  padding = 24,
  className = "",
  stiffness = 220,
  damping = 18,
}) => {
  const ref = useRef(null);
  const [hovered, setHovered] = useState(false);
  const still = useReducedMotion();

  const x = useSpring(0, { stiffness, damping, mass: 0.4 });
  const y = useSpring(0, { stiffness, damping, mass: 0.4 });

  const onMove = (e) => {
    if (still || !ref.current) return;
    const { left, top, width, height } = ref.current.getBoundingClientRect();
    x.set((e.clientX - (left + width / 2)) * strength);
    y.set((e.clientY - (top + height / 2)) * strength);
  };

  const reset = () => {
    setHovered(false);
    x.set(0);
    y.set(0);
  };

  return (
    <motion.div
      ref={ref}
      onMouseMove={onMove}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={reset}
      style={still ? undefined : { x, y }}
      className={`relative w-max ${className}`}
    >
      <span
        aria-hidden="true"
        className="absolute -z-10"
        style={{ inset: -padding }}
      />
      {typeof children === "function" ? children(hovered) : children}
    </motion.div>
  );
};

export default Magnetic;
